// Approximate 2024 UN / World Bank population estimates.
// Territory size is total area in km².
// Flag images use ISO 3166-1 alpha-2 codes via flagcdn.com.

const countries = [
  { name: 'China', code: 'cn', population: 1419321278, area: 9596961 },
  { name: 'India', code: 'in', population: 1450935791, area: 3287263 },
  { name: 'United States', code: 'us', population: 345426571, area: 9833517 },
  { name: 'Indonesia', code: 'id', population: 283487931, area: 1904569 },
  { name: 'Pakistan', code: 'pk', population: 251269164, area: 881913 },
  { name: 'Nigeria', code: 'ng', population: 232679478, area: 923768 },
  { name: 'Brazil', code: 'br', population: 211998573, area: 8515767 },
  { name: 'Bangladesh', code: 'bd', population: 173562364, area: 147570 },
  { name: 'Russia', code: 'ru', population: 144820423, area: 17098242 },
  { name: 'Ethiopia', code: 'et', population: 132059767, area: 1104300 },
  { name: 'Mexico', code: 'mx', population: 130861007, area: 1964375 },
  { name: 'Japan', code: 'jp', population: 123753041, area: 377975 },
  { name: 'Philippines', code: 'ph', population: 115843670, area: 300000 },
  { name: 'Egypt', code: 'eg', population: 116828258, area: 1002450 },
  { name: 'DR Congo', code: 'cd', population: 109276265, area: 2344858 },
  { name: 'Vietnam', code: 'vn', population: 100987686, area: 331212 },
  { name: 'Iran', code: 'ir', population: 91567738, area: 1648195 },
  { name: 'Turkey', code: 'tr', population: 87473805, area: 783562 },
  { name: 'Germany', code: 'de', population: 84552242, area: 357114 },
  { name: 'Thailand', code: 'th', population: 71801279, area: 513120 },
  { name: 'United Kingdom', code: 'gb', population: 69138192, area: 242495 },
  { name: 'Tanzania', code: 'tz', population: 68563121, area: 947303 },
  { name: 'France', code: 'fr', population: 66548575, area: 551695 },
  { name: 'South Africa', code: 'za', population: 64007139, area: 1221037 },
  { name: 'Italy', code: 'it', population: 59342867, area: 301340 },
  { name: 'Kenya', code: 'ke', population: 56432944, area: 580367 },
  { name: 'Myanmar', code: 'mm', population: 54500091, area: 676578 },
  { name: 'Colombia', code: 'co', population: 52886363, area: 1141748 },
  { name: 'South Korea', code: 'kr', population: 51717590, area: 100210 },
  { name: 'Sudan', code: 'sd', population: 50448963, area: 1861484 },
  { name: 'Uganda', code: 'ug', population: 50015092, area: 241038 },
  { name: 'Spain', code: 'es', population: 47910526, area: 505990 },
  { name: 'Algeria', code: 'dz', population: 46278755, area: 2381741 },
  { name: 'Iraq', code: 'iq', population: 46042015, area: 438317 },
  { name: 'Argentina', code: 'ar', population: 45696159, area: 2780400 },
  { name: 'Afghanistan', code: 'af', population: 42647492, area: 652230 },
  { name: 'Yemen', code: 'ye', population: 40583164, area: 527968 },
  { name: 'Canada', code: 'ca', population: 39742432, area: 9984670 },
  { name: 'Poland', code: 'pl', population: 38539201, area: 312696 },
  { name: 'Morocco', code: 'ma', population: 38081173, area: 446550 },
  { name: 'Angola', code: 'ao', population: 37855868, area: 1246700 },
  { name: 'Ukraine', code: 'ua', population: 36732000, area: 603550 },
  { name: 'Uzbekistan', code: 'uz', population: 36397502, area: 447400 },
  { name: 'Malaysia', code: 'my', population: 35126298, area: 330803 },
  { name: 'Mozambique', code: 'mz', population: 34631831, area: 801590 },
  { name: 'Ghana', code: 'gh', population: 34427423, area: 238533 },
  { name: 'Peru', code: 'pe', population: 34217651, area: 1285216 },
  { name: 'Saudi Arabia', code: 'sa', population: 36947325, area: 2149690 },
  { name: 'Madagascar', code: 'mg', population: 31964956, area: 587041 },
  { name: 'Ivory Coast', code: 'ci', population: 31977613, area: 322463 },
  { name: 'Nepal', code: 'np', population: 29651054, area: 147181 },
  { name: 'Cameroon', code: 'cm', population: 29132164, area: 475442 },
  { name: 'Venezuela', code: 've', population: 28301896, area: 916445 },
  { name: 'Niger', code: 'ne', population: 27202728, area: 1267000 },
  { name: 'Australia', code: 'au', population: 26713205, area: 7692024 },
  { name: 'North Korea', code: 'kp', population: 26418815, area: 120538 },
  { name: 'Syria', code: 'sy', population: 24672313, area: 185180 },
  { name: 'Mali', code: 'ml', population: 24478780, area: 1240192 },
  { name: 'Burkina Faso', code: 'bf', population: 23837157, area: 274200 },
  { name: 'Taiwan', code: 'tw', population: 23219645, area: 36193 },
  { name: 'Sri Lanka', code: 'lk', population: 23187516, area: 65610 },
  { name: 'Malawi', code: 'mw', population: 21656243, area: 118484 },
  { name: 'Zambia', code: 'zm', population: 21314439, area: 752612 },
  { name: 'Kazakhstan', code: 'kz', population: 20592571, area: 2724900 },
  { name: 'Chad', code: 'td', population: 20299123, area: 1284000 },
  { name: 'Chile', code: 'cl', population: 19658835, area: 756102 },
  { name: 'Romania', code: 'ro', population: 19015088, area: 238397 },
  { name: 'Somalia', code: 'so', population: 19009151, area: 637657 },
  { name: 'Senegal', code: 'sn', population: 18384720, area: 196722 },
  { name: 'Guatemala', code: 'gt', population: 18358005, area: 108889 },
  { name: 'Ecuador', code: 'ec', population: 18135117, area: 276841 },
  { name: 'Netherlands', code: 'nl', population: 17671125, area: 41543 },
  { name: 'Cambodia', code: 'kh', population: 17638801, area: 181035 },
  { name: 'Zimbabwe', code: 'zw', population: 16634503, area: 390757 },
  { name: 'Guinea', code: 'gn', population: 14754783, area: 245857 },
  { name: 'Rwanda', code: 'rw', population: 14256240, area: 26338 },
  { name: 'Benin', code: 'bj', population: 14111034, area: 114763 },
  { name: 'Burundi', code: 'bi', population: 14047780, area: 27834 },
  { name: 'Tunisia', code: 'tn', population: 12283190, area: 163610 },
  { name: 'Bolivia', code: 'bo', population: 12413315, area: 1098581 },
  { name: 'Belgium', code: 'be', population: 11715774, area: 30528 },
  { name: 'Haiti', code: 'ht', population: 11724763, area: 27750 },
  { name: 'Jordan', code: 'jo', population: 11520876, area: 89342 },
  { name: 'Dominican Republic', code: 'do', population: 11420496, area: 48671 },
  { name: 'Cuba', code: 'cu', population: 10985974, area: 109884 },
  { name: 'Czechia', code: 'cz', population: 10795216, area: 78867 },
  { name: 'Sweden', code: 'se', population: 10612199, area: 450295 },
  { name: 'Portugal', code: 'pt', population: 10425292, area: 92212 },
  { name: 'Azerbaijan', code: 'az', population: 10477428, area: 86600 },
  { name: 'Greece', code: 'gr', population: 10047817, area: 131957 },
  { name: 'Hungary', code: 'hu', population: 9676135, area: 93028 },
  { name: 'Israel', code: 'il', population: 9388728, area: 20770 },
  { name: 'Austria', code: 'at', population: 9120813, area: 83871 },
  { name: 'Switzerland', code: 'ch', population: 8921981, area: 41285 },
  { name: 'Hong Kong', code: 'hk', population: 7491609, area: 1106 },
  { name: 'Serbia', code: 'rs', population: 6735761, area: 77474 },
  { name: 'Bulgaria', code: 'bg', population: 6755425, area: 110879 },
  { name: 'Singapore', code: 'sg', population: 6031415, area: 728 },
  { name: 'Denmark', code: 'dk', population: 5977412, area: 43094 },
  { name: 'Finland', code: 'fi', population: 5617310, area: 338145 },
  { name: 'Norway', code: 'no', population: 5578989, area: 323802 },
  { name: 'Slovakia', code: 'sk', population: 5507601, area: 49035 },
  { name: 'Ireland', code: 'ie', population: 5255017, area: 70273 },
  { name: 'New Zealand', code: 'nz', population: 5228100, area: 268021 },
  { name: 'Costa Rica', code: 'cr', population: 5211650, area: 51100 },
  { name: 'Croatia', code: 'hr', population: 3875325, area: 56594 },
  { name: 'Georgia', code: 'ge', population: 3806671, area: 69700 },
  { name: 'Uruguay', code: 'uy', population: 3423108, area: 176215 },
  { name: 'Mongolia', code: 'mn', population: 3504741, area: 1564116 },
  { name: 'Bosnia and Herzegovina', code: 'ba', population: 3210847, area: 51209 },
  { name: 'Qatar', code: 'qa', population: 3048473, area: 11586 },
  { name: 'Armenia', code: 'am', population: 2973840, area: 29743 },
  { name: 'Lithuania', code: 'lt', population: 2857279, area: 65300 },
  { name: 'Jamaica', code: 'jm', population: 2825544, area: 10991 },
  { name: 'Albania', code: 'al', population: 2793592, area: 28748 },
  { name: 'Slovenia', code: 'si', population: 2119675, area: 20273 },
  { name: 'Latvia', code: 'lv', population: 1871871, area: 64589 },
  { name: 'Bahrain', code: 'bh', population: 1588670, area: 765 },
  { name: 'Estonia', code: 'ee', population: 1360546, area: 45227 },
  { name: 'Mauritius', code: 'mu', population: 1300557, area: 2040 },
  { name: 'Cyprus', code: 'cy', population: 1344976, area: 9251 },
  { name: 'Luxembourg', code: 'lu', population: 673036, area: 2586 },
  { name: 'Malta', code: 'mt', population: 539607, area: 316 },
  { name: 'Iceland', code: 'is', population: 393222, area: 103000 },
  { name: 'Montenegro', code: 'me', population: 626485, area: 13812 },
];

export const flagUrl = (code) => `https://flagcdn.com/w160/${code}.png`;
export const flagSrcSet = (code) => `${flagUrl(code)} 1x, https://flagcdn.com/w320/${code}.png 2x`;

export const formatPopulation = (n) => n.toLocaleString('en-US');

export const pickCountry = (excludeCodes = []) => {
  const exclude = new Set(excludeCodes);
  const pool = countries.filter((c) => !exclude.has(c.code));
  const source = pool.length ? pool : countries;
  return source[Math.floor(Math.random() * source.length)];
};

export const pickNext = (current, extraExclude = []) => {
  const exclude = [current.code, ...extraExclude];
  let next = pickCountry(exclude);
  let guard = 0;
  while (next.population === current.population && guard < 10) {
    next = pickCountry([...exclude, next.code]);
    guard += 1;
  }
  return next;
};

export const pickPair = () => {
  const left = pickCountry();
  const right = pickNext(left);
  return { left, right };
};

export default countries;
